import styled from 'styled-components';
import { motion } from 'framer-motion';
import { FaWhatsapp } from 'react-icons/fa';

export default function WhatsAppFloat() {
  return (
    <Btn
      as={motion.a}
      href="https://wa.me/524311011283?text=Hola%2C%20los%20contacto%20desde%20su%20sitio%20web."
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Contactar por WhatsApp"
      initial={{ scale: 0, opacity: 0 }}
      animate={{ scale: 1, opacity: 1 }}
      transition={{ delay: 2.5, type: 'spring', stiffness: 200 }}
      whileHover={{ scale: 1.1 }}
      whileTap={{ scale: 0.95 }}
    >
      <FaWhatsapp size={28} />
      <Pulse />
    </Btn>
  );
}

const Btn = styled.a`
  position: fixed;
  bottom: 2rem;
  right: 2rem;
  z-index: 2000;
  width: 60px;
  height: 60px;
  border-radius: 50%;
  background: var(--green-wa);
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 8px 30px rgba(37,211,102,0.4);
  cursor: pointer;
`;

const Pulse = styled.div`
  position: absolute;
  inset: 0;
  border-radius: 50%;
  background: var(--green-wa);
  opacity: 0.4;
  animation: pulse 2s ease-out infinite;

  @keyframes pulse {
    0%   { transform: scale(1); opacity: 0.4; }
    70%  { transform: scale(1.6); opacity: 0; }
    100% { transform: scale(1.6); opacity: 0; }
  }

  @media (prefers-reduced-motion: reduce) {
    animation: none;
  }
`;
